import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  inputWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    alignItems: 'center',
  },
  applyButton: {
    height: '40px',
  },
  input: {
    minWidth: '351px',
  },
  tcv: {
    background: theme.palette.bgV2.light,
    padding: `${theme.spacing(3)}px !important`,
    borderRadius: '4px',
  },
  currencyClass: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#6A777A',
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  alignTypography: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  currency: {
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    fontSize: '14px',
  },
  price: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '-8px',
  },
  disabledApply: {
    marginBottom: theme.spacing(2),
  },
  markupWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  description: {
    marginBottom: theme.spacing(-1.75),
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: ' #6A777A',
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(0.5),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  companyDetailsContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    width: '100%',
  },
  inputWidth: {
    width: '50%',
  },
  inputFullWidth: {
    width: '100%',
  },
  sectionHeading: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  //   errorMessage: {
  //     color: theme.palette.error.dark,
  //     fontSize: '12px',
  //     marginTop: theme.spacing(1),
  //     fontStyle: 'normal',
  //     fontWeight: 400,
  //     lineHeight: '16px',
  //   },
  flexiblePaymentTermWrapper: {
    marginTop: theme.spacing(-1),
    height: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(3, 4),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  elementsGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  titleWraper: {
    display: 'flex',
    gap: theme.spacing(4),
    width: '100%',
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  columnName: {
    width: '50%',
  },
  fontSize: {
    fontSize: '12px',
  },
  fontSizeDesc: {
    fontSize: '14px',
  },
  border: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  resourceRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  resourcesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  alignDescription: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  descHeightWidth: {
    width: '50%',
  },
  textStyle: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
}))
